import { webapi } from '@/api/webapi.ts';
import { cancelEsp } from '@/store/esp/api/cancelEsp.ts';
import { getEspLimits } from '@/store/esp/api/getEspLimits.ts';
import { getEspTiering } from '@/store/esp/api/getEspTiering.ts';
import { refreshEsp } from '@/store/esp/api/refreshEsp.ts';
import { requestEsp } from '@/store/esp/api/requestEsp.ts';

export const espApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    getEspTiering: getEspTiering(builder),
    requestEsp: requestEsp(builder),
    cancelEsp: cancelEsp(builder),
    getEspLimits: getEspLimits(builder),
    refreshEsp: refreshEsp(builder),
  }),
});

export const {
  useGetEspTieringQuery,
  useRequestEspMutation,
  useCancelEspMutation,
  useGetEspLimitsQuery,
  useRefreshEspMutation,
} = espApi;
